// https://material.angular.io/components/table/overview
import { Component, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import { FacturaEliminarComponent } from './factura-eliminar.component';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DomSanitizer } from '@angular/platform-browser';
import { PersonalPDF, Personal } from '../../models/personal';
import * as moment from 'moment';
import { FormControl, Validators } from '@angular/forms';
import { FacturaDetalleComponent } from '../agregar-editar/factura-detalle.component';
import {CartaPorte } from '../cartaPorte/carta-porte.component'
import { Factura } from '../../models/factura';
import { Cliente } from '../../models/cliente';
import { SelectionModel } from '@angular/cdk/collections';
import { ExcelServiceHeader } from '../../utils/excel.service';
import { FacturaDetalle } from '../../models/facturaDetalle';
import { FacturaRegimenFiscal } from '../../models/facturaRegimenFiscal';
import { FacturaFormaPago } from '../../models/facturaFormaPago';
import { FacturaMetodoPago } from '../../models/facturaMetodoPago';
import { FacturaUsoCFDI } from '../../models/facturaUsoCFDI';
import { FacturaItem } from '../../models/facturaItem';
import { FacturaItemSAT } from '../../models/facturaItemSAT';
import { FacturaUnidadMedida } from '../../models/facturaUnidadMedida';
import { Organizacion } from '../../models/organizacion';
import { Usuario } from '../../models/usuario';
import { FacturaDescargarComponent } from './factura-descargar.component';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common'
import{modalFechaPagoFactura} from '../consultar-eliminar/fechaPago/fecha-pago.component'

/**
 * @title Table with pagination
 */
@Component({
  selector: 'my-factura-consultar',
  styleUrls: ['factura-consultar.component.scss'],
  templateUrl: 'factura-consultar.component.html',
  providers: [generalService, ExcelServiceHeader]
})
export class FacturaConsultarComponent {

  public viewDataCliente: any[];
  private itemsShow = 10;
  private filteredItemsShowCliente = 10;
  private arrayFilteredCliente = undefined;
  private isFilteredCliente = false;
  @ViewChild('infiniteSelect') selectElem: MatSelect;

  public datosGeneralesSAE: any;
  dataSource: DataSourceGrid | null;
  displayedColumns = ['acciones', 'CUSTOMER_NAME', 'DESCRIPTION_STATUS',  'BILL_NUMBER', 'UUID','BILL_TYPE', 'SUBTOTAL_BEFORE_TAX', 'TOTAL_IVA', 'TOTAL', 'CREATION_DATE'];
  dataSource2: DataSourceGrid | null;
  displayedColumns2 = ['check', 'numeroVenta', 'numeroFactura', 'nombreCliente', 'nombrePersonal', 'fechaVenta', 'status', 'nombreCreador', 'fechaCreacion', 'totalVenta'];

  public listaFactura: any = [];
  public listaVentas: any[] = [];
  tipoFecha = 0;
  tipoDocumento = 0;
  tipoFactura = 2;
  public cantidad = 0;
  public irVentas = false;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public BILL_TAX_REGIME_ID: number;
  public BILL_CFDI_USE_ID: number;

  public listaCliente: Cliente[] = [];
  public menuItemsPerfil: Array<any> = [];
  public factura: Factura = null;
  listaFacturaDetalle: FacturaDetalle[] = [];
  listaFacturaDetalleImpuestosRetenidos: any[] = [];
  listaFacturaDocumentosRelacionados: any[] = []; // Sustitución (CFDI Relacionados, TipoRelacion 04)

  public fechasForm = new FormControl(null, [Validators.required]);
  public clienteForm = new FormControl(null, [Validators.required]);
  public folioForm = new FormControl('', [Validators.maxLength(20)]);

  public btnSubmit = false;

  public FechaPago = false;
  

  public lstTipoVenta: any[];
   // Configuracion del daterangepicker
   locale: {
    format: 'DD/MM/YYYY',
    separator: ' - ',
    cancelLabel: 'Cancelar',
    applyLabel: 'Aceptar',
    firstDay: 1 // first day is monday
  };
  // date = new Date();
  // maxDate = moment().add(365, 'days');
  ranges: any = {

    'Hoy': [moment(), moment()],
    'Semana actual': [moment().startOf('week'), moment().endOf('week')],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')]

    // 'Hoy': [moment(), moment()],
    // 'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    // 'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()],

    /* 'Mes pasado': [moment().subtract(1, 'month').startOf('month'), moment(), moment()], */
    /* 'Semana actual': [moment().startOf('week'), moment().endOf('week')], */
    /* 'Ultimos 3 meses': [moment().subtract(3, 'month').startOf('month'), moment(), moment()] */
  };

  // dateRange: any = {
  //   startDate: moment().startOf('month'),
  //   endDate: moment()
  // };

  dateRange: any = {
    startDate: moment().startOf('month'),
    //startDate: moment().subtract(7, 'days'),
    endDate: moment()
  };

  public seleccionado: any;
  selectionMultiple = new SelectionModel<any>(true, []);

  public idDocuments: string = '';

  nombreCliente: string = null;
  rfcCliente: string = null;
  idSucursal: number = null;
  public iconoMostar = true;

  listaRegimenFiscal: FacturaRegimenFiscal[] = [];
  listaFormaPago: FacturaFormaPago[] = [];
  listaMetodoPago: FacturaMetodoPago[] = [];
  listaCFDI: FacturaUsoCFDI[] = [];
  listaSATCode: any[] = [];
  listaCargo: any[] = [];

  // arreglos Carta Porte 
  public listaCartaPorte:any [] = [];
  public listaCartaPorteDetallePesoCarga:any [] = [];
  public lista_CartaPorteDetallePesoCarga:any [] = [];
  //public listaCartaPorteDetalleServicos:any [] = [];
  public listaCartaPorteDetalleTrasporte:any [] = [];
  public listaCartaPorteDetalleUbicaciones:any [] = [];
  public lista_CartaPorteDetalleUbicaciones:any [] = [];
  public CartaPotefull = false;


  listaProducto: FacturaItem[] = [];
  listaItemSAT: FacturaItemSAT[] = [];
  listaUnidad: FacturaUnidadMedida[] = [];
  listaSucursal: Organizacion[] = [];

  public PDF = null;
  public XML = null;
  public FILENAME_XML = '';
  public FILENAME_PDF = '';
  public cartaPorteEstado = 'F';
  public bloquearBtnGuardar = true;

  constructor(private _generalService: generalService, public dataService: DataService, public dialog: MatDialog, private sanitizer: DomSanitizer, public excelHeader: ExcelServiceHeader,
    public datePipe: DatePipe) {
    this.datosGeneralesSAE = DatosGeneralesSAE;
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginator2: MatPaginator;

  consultarFacturas() {
    
    this.datosGeneralesSAE.showSpinnerLoading = true;
    if (this.dateRange.startDate !== null && this.dateRange.endDate !== null /*&& this.clienteForm.value !== null*/) {

      const factura: any = {};

      factura.loacs = sessionStorage.getItem('acslo');
      factura.fechaInicio = this.dateRange.startDate.format('YYYY-MM-DD 00:00:00');
      factura.fechaFin = this.dateRange.endDate.format('YYYY-MM-DD 23:59:59');
      factura.idCliente = this.clienteForm.value;
      factura.folio = (this.folioForm.value === null) ? '' : this.folioForm.value;
      this._generalService.metodoCallParams(factura, 'factura/consultBills').subscribe(
          (result) => {
            this.listaFactura = JSON.parse(result);
            this.dataSource = new DataSourceGrid(this.listaFactura, this.paginator, this.sort);
            this.cantidad = this.listaFactura.length;
            
            // if(this.listaFactura[0].RECEIVER_PAYMENT_METHOD_ID == 1 ){
            //   this.FechaPago = true;
            // }
            this.listaFactura.forEach(element => {
              if (element.BILL_TYPE === "I") {
                element.BILL_TYPE_AUX = 'N / A';
              } else if (
                element.BILL_TYPE !== "I" &&
                element.BILL_CARTA_PORTE_ID === null
              ) {
                element.BILL_TYPE_AUX = 'Pendiente';
              } else if (
                element.BILL_TYPE !== "I" &&
                element.BILL_CARTA_PORTE_ID !== null
              ) {
                element.BILL_TYPE_AUX = 'Sí';
              }
          });      

            if (this.listaFactura.length <= 0) {
              $('.mat-row').remove('.mat-row');
              this._generalService.toastCall('No se encontraron registros');
            }
            
            
            this.datosGeneralesSAE.showSpinnerLoading = false;
          },
            
          (error) => {
            this.datosGeneralesSAE.showSpinnerLoading = false;
          }
        );
    } else {
      this.datosGeneralesSAE.showSpinnerLoading = false;
      this._generalService.toastCall('Las fechas son requeridas');
    }
  }

  consultarEstatusActual() {
    if (this.dateRange.startDate !== null && this.dateRange.endDate !== null /*&& this.clienteForm.value !== null*/) {
      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idOrganizacion = usuarioSession.ORGANIZATION_ID;
      const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
      
      const factura: any = {};

      factura.ORGANIZATION_ID = idOrganizacion;
      factura.idCompania = idCompania;
      factura.loacs = sessionStorage.getItem('acslo');
      factura.fechaInicio = this.dateRange.startDate.format('YYYY-MM-DD 00:00:00');
      factura.fechaFin = this.dateRange.endDate.format('YYYY-MM-DD 23:59:59');
      factura.idCliente = this.clienteForm.value;
      factura.folio = (this.folioForm.value === null) ? '' : this.folioForm.value;
      
      console.warn(factura);
      this._generalService.metodoCallParams(factura, 'factura/updateStatus').subscribe(
          (result) => {
            this._generalService.toastCall('Se actualizó el estatus a las facturas exitosamente!');
            this.consultarFacturas();
          },
          (error) => {
            
          }
        );
    } else {
      this._generalService.toastCall('Las fechas son requeridas');
    }
  }

  seleccionaRow(row) {
    
  }

  getDocumentsTypes() {
    this._generalService.requestGet('venta/GetDocumentsTypes').subscribe(
        (result) => {
            this.lstTipoVenta = JSON.parse(result);
            if (this.lstTipoVenta.length > 0) {
              const index = this.lstTipoVenta.findIndex((element) => element.DOCUMENT_TYPE_ID === 3);
              this.lstTipoVenta.splice(index, 1);
            }
            // this.getDocuments();
        },
        (error) => {
            const errorMsj =  error as any;
            console.error(errorMsj);
        }
    );
}

  descargarPDF() {

  }

  cargarVentas() {
    if (this.clienteForm.value !== null && this.clienteForm.value !== undefined) {
      this.dateRange = {
        startDate: moment().startOf('month'),
        endDate: moment()
      };
      this.irVentas = true;
      this.tipoFactura = 1;
      this.consultarVentas();
    } else {
      this._generalService.toastCall('El cliente es requerido!');
      this.clienteForm.markAsTouched();
    }
  }

  regresarFacturas() {
    this.irVentas = false;
    this.listaVentas = [];
    this.tipoDocumento = 0;
    this.tipoFecha = 0;
    this.dateRange = {
      startDate: moment().startOf('month'),
      endDate: moment()
    };
    this.tipoFactura = 2;

  }

  consultarVentas() {
    const paramsJSON = {
      START_DATE: this.dateRange.startDate.format('YYYY-MM-DD 00:00:00'),
      END_DATE: this.dateRange.endDate.format('YYYY-MM-DD 23:59:59'),
      TIPO_FECHA: this.tipoFecha,
      DOCUMENT_TYPE_ID: this.tipoDocumento,
      USER_ID: this.userData.USER_ID,
      CUSTOMER_ID: this.clienteForm.value
  };
    this._generalService.requestGet('factura/GetDocuments?parametros=' + JSON.stringify(paramsJSON)).subscribe(
        (result) => {
            const tableResult = JSON.parse(result);
            this.listaVentas = tableResult.Table;
            this.dataSource2 = new DataSourceGrid(this.listaVentas, this.paginator2, this.sort);
            if (this.listaVentas.length <= 0) {
                $('.mat-row').remove('.mat-row');
            }
        },
        (error) => {
          
        }
    );
}

  changeCliente() {
    if (this.clienteForm.value !== null) {
      const cliente = this.listaCliente.find((element) => element.idCliente === this.clienteForm.value);
      this.rfcCliente = cliente.rfc;
      this.nombreCliente = cliente.razonSocial;
    } else {
      this.rfcCliente = null;
      this.nombreCliente = null;
    }
  }

  
  editar(idFactura: number, idCliente: number) {
    this.dataService.id = idFactura;
    this.dataService.tipo = 'editar';
    this.idDocuments = null;
    this.dataService.factura = {
      idDocuments: this.idDocuments,
      tipoFactura: this.tipoFactura,
      idCliente: this.clienteForm.value ? this.clienteForm.value : idCliente,
      CUSTOMER_NAME: this.nombreCliente,
      CUSTOMER_RFC: this.rfcCliente
    };
    const dialogRef = this.dialog.open(FacturaDetalleComponent, {disableClose: true, width: '95vw', height: '90vh', maxWidth: '95vw', maxHeight: '95vh', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if (this.dataService.guardado) {
        this._generalService.toastCall('El registro se modificó exitosamente!');
        this.consultarFacturas();
        this.regresarFacturas();
      }
    });
  }

  agregar() {
    //if (this.clienteForm.value !== null && this.clienteForm.value !== undefined) {
      this.dataService.id = null;
      this.dataService.tipo = 'agregar';
      this.idDocuments = '';
      if (this.selectionMultiple.selected.length > 0 ) {
        this.selectionMultiple.selected.forEach((element) => {
          this.idDocuments += element.DOCUMENT_ID + ',';
        });
        this.idDocuments = this.idDocuments.slice(0, -1);
      }

      //Se prepara para enviar el BILL_TAX_REGIME_ID al modal
      for(let i = 0; i < this.listaCliente.length; i ++){
        if(this.listaCliente[i].idCliente == this.clienteForm.value){
          this.BILL_TAX_REGIME_ID = this.listaCliente[i].BILL_TAX_REGIME_ID;
          this.BILL_CFDI_USE_ID = this.listaCliente[i].BILL_CFDI_USE_ID;
          break;
        }
      }

      this.dataService.factura = {
        idDocuments: this.idDocuments,
        tipoFactura: this.tipoFactura,
        idCliente: this.clienteForm.value,
        CUSTOMER_NAME: this.nombreCliente,
        CUSTOMER_RFC: this.rfcCliente,
        BILL_TAX_REGIME_ID: this.BILL_TAX_REGIME_ID,
        BILL_CFDI_USE_ID: this.BILL_CFDI_USE_ID
      };
    // this.dataService.idDocuments = this.idDocuments;
    // this.dataService.tipoFactura = this.tipoFactura;
      const dialogRef = this.dialog.open(FacturaDetalleComponent, {
        disableClose: true, width: '95vw', height: '80vh', maxWidth: '95vw', maxHeight: '95vh', panelClass: 'full-width-dialog'
      });
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
        if (this.dataService.guardado) {
          this._generalService.toastCall('El registro se agregó exitosamente!');
          this.consultarFacturas();
          this.regresarFacturas();
        }
      });
    // } 
    // else {
    //   this._generalService.toastCall('El cliente es requerido!');
    //   this.clienteForm.markAsTouched();
    // }
  }

  consultarClientes() {
    const factura: any = {};
    factura.loacs = sessionStorage.getItem('acslo');

    this._generalService.metodoCallParams(factura, 'cliente/consultarClientes').subscribe(
        (result) => {
          console.log(result);
          if ( JSON.parse(result) !== null &&  JSON.parse(result) !== undefined) {
            this.listaCliente = JSON.parse(result);
            this.viewDataCliente = this.listaCliente.slice(0, 10);
          } else {
            this.listaCliente = [];
          }
          },
        (error) => {
         
        }
      );
  }

  ngOnInit() {
    this.validarVistaBtn();

    /***************************INFINITE SELECT**********************************/    
     setTimeout(() => 
                this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
            2);
    /***************************INFINITE SELECT**********************************/
  }

  eliminarConfirm(data: any) {
    console.warn(data);
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.dataService.id = data.BILL_ID;

      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idOrganizacion = usuarioSession.ORGANIZATION_ID;
      const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
      this.dataService.factura = {idOrganizacion, idCompania,
        uuid: data.UUID, 
        TOTAL: data.TOTAL, 
        //MOTIVO: "02", 
        CUSTOMER_ID:data.CUSTOMER_ID,
        BILL_ID:data.BILL_ID,
         BILL_NUMBER: data.BILL_NUMBER
        };

      const dialogRef = this.dialog.open(FacturaEliminarComponent, {disableClose: true});
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
          this.consultarFacturas();
          this.btnSubmit = false;
        });
    } else {
      this.btnSubmit = false;
    }
  }

  public ExportarExcel() {
      const hoy = new Date();
      const fecha = hoy.getDate() + '/' + ( hoy.getMonth() + 1 ) + '/' + hoy.getFullYear();
      const hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds();
      const fechayHora = fecha + ' ' + hora;

      const datosHeader = {

        //cliente: this.nombreCliente,
        cliente: this.userData.FISCAL_NAME,
        //rfc: this.rfcCliente,
        rfc: this.userData.RFC,
        //segundoTextoHeader: 'MRSAE',
        segundoTextoHeader:  this.userData.ADDRESS,
        tercerTextoHeader: 'Resumen de Documentos',
        fechaHoraImpresion: fechayHora,
        numeroPagina: 'Página 1 de 1'
      };

      if ( this.listaFactura.length > 0) {

        for(let i = 0; i < this.listaFactura.length; i ++){
          this.listaFactura[i].FECHA = this.datePipe.transform(this.listaFactura[i].CREATION_DATE, 'dd/MM/yyyy')
        }

        const filename = 'resumen-documentos' ;

        const columns = [ {display: 'Numero De Folio', name: 'BILL_NUMBER', tipoDato: 'string'},
                          {display: 'Fecha', name: 'FECHA', tipoDato: 'string'},
                          {display: 'UUID', name: 'UUID', tipoDato: 'string'},
                          {display: 'Método de Pago', name: 'BILL_PAYMENT_METHOD_KEY', tipoDato: 'string'},
                          {display: 'Estatus Pago', name: 'Pagada', tipoDato: 'string'},
                          {display: 'Fecha Pago', name: 'FechaPago', tipoDato: 'string'},
                          {display: 'Fecha Vencimiento', name: 'FechaVencimiento', tipoDato: 'string'},
                          {display: 'Cliente', name: 'CUSTOMER_NAME', tipoDato: 'string'},
                          {display: 'Estatus', name: 'DESCRIPTION_STATUS', tipoDato: 'string'},
                          {display: 'Subtotal', name: 'SUBTOTAL_BEFORE_TAX', tipoDato: 'moneda'},
                          {display: 'IVA', name: 'TOTAL_IVA', tipoDato: 'moneda'},
                          {display: 'Total', name: 'TOTAL', tipoDato: 'moneda'},
                      ];

        this.excelHeader.exportXlsTableView( this.listaFactura, columns, filename, datosHeader);
      }
  }

  /*filtrar(filtro) {
      if (this.listaFactura.length <= 0) {
        $('.mat-row').remove('.mat-row');
      } else {
        let filteredData = this.listaFactura;
        if (filtro !== '') {
              filteredData = this.listaFactura.slice().filter((item: any) => {
                  if (
                      item.COLUMN1.toLowerCase().indexOf(filtro.toLowerCase()) != -1 ||
                      item.COLUMN2.toLowerCase().indexOf(filtro.toLowerCase()) != -1 ||
                      item.COLUMN3.toLowerCase().indexOf(filtro.toLowerCase()) != -1 ||
                      item.COLUMN4.toLowerCase().indexOf(filtro.toLowerCase()) != -1
                    ) {
                    return true;
                  } else {
                    return false;
                  }
              });
        }
        this.dataSource = new DataSourceGrid(filteredData, this.paginator, this.sort);
        this.cantidad = filteredData.length;
      }
  }*/

  timbrarFactura(id: any, idCliente: any) {
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.factura = new Factura();
      this.factura.BILL_ID = id;
      this._generalService.metodoCallParams(this.factura, `factura/getBill/`).subscribe(
          (result) => {
              const res = JSON.parse(result);
              console.warn(res);
            
              if (res.length > 0) {
                  this.factura = res[0];
                  this._generalService.metodoCallParams(this.factura, `factura/getBillDetail/`).subscribe(
                      (result2) => {
                          const res2 = JSON.parse(result2);
                          console.warn(res2);
                          this.listaFacturaDetalle = res2;
                          
                          this._generalService.metodoCallParams(this.factura, `factura/getBillDetailImpuestoRetenido/`).subscribe(
                            (result3) => {
                                const res3 = JSON.parse(result3);
                                console.warn(res3);
                                this.listaFacturaDetalleImpuestosRetenidos = res3;


                                this.cargarDocumentosRelacionados(this.factura.BILL_ID, () => this.enviar(idCliente));
      
                            },
                            (error) => {
                              this.btnSubmit = false;
                              this.datosGeneralesSAE.showSpinnerLoading = false;
                            
                            }
                        );
                          
                         // this.enviar(idCliente);

                      },
                      (error) => {
                        this.btnSubmit = false;
                        this.datosGeneralesSAE.showSpinnerLoading = false;
                      
                      }
                  );

              } else {
                this.btnSubmit = false;
                this.datosGeneralesSAE.showSpinnerLoading = false;
              }
              
          },
          (error) => {
            this.btnSubmit = false;
            this.datosGeneralesSAE.showSpinnerLoading = false;
           
          }
      );
    }
  }

  validacionFacturasTimbradas(id: any, idCliente: any, tipoFactura: any, cartaPorte: any){
    
    this.CartaPotefull = false;

    if (cartaPorte !== null || tipoFactura == "I"){
      this.estableserValoreCartaPorte();
  
      let metodo = 'factura/getDetalleCartaPorte_Timbrado';
      const params = {
          
          BILL_ID:id, 
          loacs: sessionStorage.getItem('acslo')
      };
  
      this._generalService.metodoCallParams(params, metodo).subscribe(
          (result) => {
            const tableResult = JSON.parse(result);
            this.listaCartaPorte = tableResult.Table;
            this.listaCartaPorteDetallePesoCarga = tableResult.Table1;
            //this.listaCartaPorteDetalleServicos = tableResult.Table2;
            this.listaCartaPorteDetalleTrasporte = tableResult.Table3;
            this.listaCartaPorteDetalleUbicaciones = tableResult.Table4;
  
            if(this.listaCartaPorte.length > 0
               && this.listaCartaPorteDetallePesoCarga.length > 0
              // && this.listaCartaPorteDetalleServicos.length > 0
               && this.listaCartaPorteDetalleTrasporte.length > 0
               && this.listaCartaPorteDetalleUbicaciones.length > 0 ){
                 this.CartaPotefull = true;
            }

            if( this.CartaPotefull || tipoFactura == "I"){
              let metodo = 'factura/validacionFacturasTms';
              const factura: any = {};
              factura.loacs = sessionStorage.getItem('acslo');
              var contador=0;
              var companyNew;
              this._generalService.metodoCallParams(factura, metodo).subscribe(
                  (result) => {
                    const tableResult = JSON.parse(result);
                    contador = tableResult.Table[0].Cantidad_Facturas_Timbradas;
                    companyNew = tableResult.Table1[0].COMPANY_NEW;
                    
                    if (companyNew === 1) {
                      if (contador <= 19) {
                        this.timbrarFactura(id,idCliente);
                        
                      } else {
                        this._generalService.toastCall("No es posible timbrar la factura, ha llegado al límite máximo, contactarse con administrador.") 
                        }
                    } else if (companyNew === 0 || companyNew === null) {
                      this.timbrarFactura(id,idCliente);
                    
                    } 
                  },
                  (error) => {
                  const errorMsj =  error as any;
                  console.log(errorMsj);
                  }
              );
            }else{
              this._generalService.toastCall('Faltan datos Carta Porte');
              this.bloquearBtnGuardar = true;
            }
          },
          (error) => {
          const errorMsj =  error as any;
          console.log(errorMsj);
          }
      );

    }else{
      this._generalService.toastCall('Carta Porte Pendiente');
      this.bloquearBtnGuardar = true;
      
    }
  }
  evitardobleClic(row: any) {
    if (this.bloquearBtnGuardar) {
      this.bloquearBtnGuardar = false;
      
      this.validacionFacturasTimbradas(row.BILL_ID, row.CUSTOMER_ID, row.BILL_TYPE, row.BILL_CARTA_PORTE_ID);
    }
  }

  estableserValoreCartaPorte(){
    this.listaCartaPorte = [];
    this.listaCartaPorteDetallePesoCarga =[];
    //this.listaCartaPorteDetalleServicos = [];
    this.listaCartaPorteDetalleTrasporte = [];
    this.listaCartaPorteDetalleUbicaciones = [];
  }
  getCartaPorteDetalle(id: any){
    this.estableserValoreCartaPorte();

    let metodo = 'factura/getDetalleCartaPorte_Timbrado';
    const params = {
        
        BILL_ID:id, 
        loacs: sessionStorage.getItem('acslo')
    };

    this._generalService.metodoCallParams(params, metodo).subscribe(
        (result) => {
          const tableResult = JSON.parse(result);
          this.listaCartaPorte = tableResult.Table;
          this.listaCartaPorteDetallePesoCarga = tableResult.Table1;
         // this.listaCartaPorteDetalleServicos = tableResult.Table2;
          this.listaCartaPorteDetalleTrasporte = tableResult.Table3;
          this.listaCartaPorteDetalleUbicaciones = tableResult.Table4;

          if(this.listaCartaPorte.length > 0
             && this.listaCartaPorteDetallePesoCarga.length > 0
             //&& this.listaCartaPorteDetalleServicos.length > 0
             && this.listaCartaPorteDetalleTrasporte.length > 0
             && this.listaCartaPorteDetalleUbicaciones.length > 0 ){
            this.CartaPotefull = true;
          }
        },
        (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
        }
    );

}

  download(id: any, idCliente: any) {
    this.estableserValoreCartaPorte();
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.factura = new Factura();
      this.factura.BILL_ID = id;
      this._generalService.metodoCallParams(this.factura, `factura/getBill/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res.length > 0) {
                    this.factura = res[0];
                    this._generalService.metodoCallParams(this.factura, `factura/getBillDetail/`).subscribe(
                        (result2) => {
                            const res2 = JSON.parse(result2);
                          
                            this.listaFacturaDetalle = res2;


                            const params = {
                              BILL_ID:id, 
                              loacs: sessionStorage.getItem('acslo')
                            };
                      
                          this._generalService.metodoCallParams(params, 'factura/getDetalleCartaPorte_Timbrado').subscribe(
                              (result) => {
                                const tableResult = JSON.parse(result);
                                this.listaCartaPorte = tableResult.Table;
                                this.listaCartaPorteDetallePesoCarga = tableResult.Table1;
                                //this.listaCartaPorteDetalleServicos = tableResult.Table2;
                                this.listaCartaPorteDetalleTrasporte = tableResult.Table3;
                                this.listaCartaPorteDetalleUbicaciones = tableResult.Table4;
                                
                                
                                this._generalService.metodoCallParams(this.factura, `factura/getBillDetailImpuestoRetenido/`).subscribe(
                                  (result3) => {
                                      const res3 = JSON.parse(result3);
                                      console.warn(res3);
                                      this.listaFacturaDetalleImpuestosRetenidos = res3;


                                      this.cargarDocumentosRelacionados(this.factura.BILL_ID, () => this.recuperarArchivos(idCliente));
            
                                  },
                                  (error) => {
                                    this.btnSubmit = false;
                                    this.datosGeneralesSAE.showSpinnerLoading = false;
                                  
                                  }
                              );
   
                                
                            },
                              (error) => {
                              const errorMsj =  error as any;
                              console.log(errorMsj);
                              }
                          );     
                        },
                        (error) => {
                          this.btnSubmit = false;
                          this.datosGeneralesSAE.showSpinnerLoading = false;
                      
                        }
                    );

                } else {
                  this.btnSubmit = false;
                  this.datosGeneralesSAE.showSpinnerLoading = false;
                }
            },
            (error) => {
              this.btnSubmit = false;
              this.datosGeneralesSAE.showSpinnerLoading = false;
      
            }
        );
        }
  }

  enviar(idCliente: any) {
      const params = this.generarComprobante(idCliente);
      console.warn(params);
      
      this._generalService.requestPostParams(params, 'factura/recibirDatos/').subscribe(
      (result) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const archivo = JSON.parse(result);
        this.PDF = archivo.PDF;
        this.XML = archivo.XML;
        this.FILENAME_XML = archivo.FILENAME_XML;
        this.FILENAME_PDF = archivo.FILENAME_PDF;

        const dialogRef = this.dialog.open(FacturaDescargarComponent,  {disableClose: true}
          );

        dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            // this.descargarArchivos();
            this.btnSubmit = false;
            this.bloquearBtnGuardar = true;
            this.download(params.factura.BILL_ID, idCliente);
          }
          this.btnSubmit = false;
          this.bloquearBtnGuardar = true;
          this.consultarFacturas();
        });

      },
      (error) => {
        this.btnSubmit = false;
        this.bloquearBtnGuardar = true;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
      
      }
    );
    
  }

  recuperarArchivos(idCliente: any) {
      const params = this.generarComprobante(idCliente);
      this._generalService.requestPostParams(params, 'factura/descargarArchivosFactura/').subscribe(
        (result) => {
          this.btnSubmit = false;
          this.datosGeneralesSAE.showSpinnerLoading = false;
          const archivo = JSON.parse(result);
          this.PDF = archivo.PDF;
          this.XML = archivo.XML;
          this.FILENAME_XML = archivo.FILENAME_XML;
          this.FILENAME_PDF = archivo.FILENAME_PDF;
          this.descargarArchivos();
          this.consultarFacturas();
        },
        (error) => {
          this.datosGeneralesSAE.showSpinnerLoading = false;
          this._generalService.handleError(error);
          this.btnSubmit = false;
        }
      );
  }

  generarComprobante(idCliente: any) {
    const conceptos: any = [];
    this.lista_CartaPorteDetalleUbicaciones = [];
    this.lista_CartaPorteDetallePesoCarga = [];
    let tieneImpuestos = false;
    const unidadSAT = this.listaRegimenFiscal.find((ele) => ele.BILL_TAX_REGIME_ID === this.factura.TAX_REGIME_ID);

    this.listaFacturaDetalle.forEach((facturaDetalle) => {
      console.warn(facturaDetalle);
        const unidad = this.listaUnidad.find((ele) => ele.BILL_UNIT_MEASURE_ID === facturaDetalle.UNIT_MEASURE_ID);
        const sat =  this.listaSATCode.find((p) => p.itemSATcodeId === facturaDetalle.ITEM_SAT_ID);
        const impuestosRetenidosDetalle = this.listaFacturaDetalleImpuestosRetenidos.filter(impuesto => impuesto.BILL_DETAIL_ID === facturaDetalle.BILL_DETAIL_ID);
        conceptos.push({
          Importe: facturaDetalle.AMOUNT,
          ClaveProdServ: sat.SATcode,
          cantidad: facturaDetalle.QUANTITY,
          ClaveUnidad: unidad.BILL_UNIT_MEASURE_KEY,
          Descripcion: facturaDetalle.DESCRIPTION,
          ValorUnitario: Math.round(((facturaDetalle.AMOUNT / facturaDetalle.QUANTITY) + Number.EPSILON) * 100) / 100,
          Unidad: unidad.NAME,
          baseField: facturaDetalle.AMOUNT,
          objetoImp: "02",
          /*impuestosRetenidos: {
            impuestosRetenidosDetalle
          },*/
        //  cuentaPredial : {
        //     //Numero : facturaDetalle.NAME_PREDIAL  
        //  }
         
          /*Impuestos: {
            Traslados: []
          }*/

        });
        
        if(facturaDetalle.NAME_PREDIAL != null)
        {
          conceptos[conceptos.length - 1].cuentaPredial = {};  
          conceptos[conceptos.length - 1].cuentaPredial = new Array();
          conceptos[conceptos.length - 1].cuentaPredial.push(
            {
              Numero: facturaDetalle.NAME_PREDIAL  
            }
          );    
          //conceptos[conceptos.length - 1].cuentaPredial.Numero = new Array();
        }
      
        if (facturaDetalle.IVA_FACTOR > 0 || impuestosRetenidosDetalle != null) {
          conceptos[conceptos.length - 1].Impuestos = {};
          tieneImpuestos = true;
          conceptos[conceptos.length - 1].Impuestos.Traslados = new Array();
          if (facturaDetalle.IVA_FACTOR > 0)
          {
              conceptos[conceptos.length - 1].Impuestos.Traslados.push(
                {Importe:  facturaDetalle.IVA_AMOUNT.toFixed(6), importeFieldSpecified: true, TasaOCuota:  facturaDetalle.IVA_FACTOR.toString() + '0000', tasaOCuotaFieldSpecified: true, TipoFactor: 'Tasa', Impuesto: '002', objetoImp:'002',Base: facturaDetalle.AMOUNT,
                baseField: facturaDetalle.AMOUNT
              }
              );    
          }
          if (impuestosRetenidosDetalle != null) {
            conceptos[conceptos.length - 1].Impuestos.Retenciones = new Array();
            impuestosRetenidosDetalle.forEach(impuestosRetenidosDetalle => {
              conceptos[conceptos.length - 1].Impuestos.Retenciones.push({
                  // Aquí puedes definir las propiedades del objeto a agregar
                  importeFieldSpecified: true,
                  tasaOCuotaFieldSpecified: true,
                  TipoFactor: 'Tasa',
                  Impuesto: '001',
                  objetoImp: '002',
                  Importe:  impuestosRetenidosDetalle['AMOUNT'],
                  Base: impuestosRetenidosDetalle['BASE'],
                  baseField: impuestosRetenidosDetalle['BASE'],
                  TasaOCuota: impuestosRetenidosDetalle['TAX_VALUE']
              });
          });
          
          } 
        } else {
         // conceptos
        }
    });

    const formaPago = this.listaFormaPago.find((ele) => ele.BILL_PAYMENT_FORM_ID === this.factura.RECEIVER_PAYMENT_FORM_ID);
    const metodoPago = this.listaMetodoPago.find((ele) => ele.BILL_PAYMENT_METHOD_ID === this.factura.RECEIVER_PAYMENT_METHOD_ID);


    const formaPagoNull = (formaPago === undefined) ? true : false;
    const metodoPagoNull = (metodoPago === undefined) ? true : false;


    const regimenFiscal = this.listaRegimenFiscal.find((ele) => ele.BILL_TAX_REGIME_ID === this.factura.TAX_REGIME_ID);

    const usoCFDI = this.listaCFDI.find((ele) => ele.BILL_CFDI_USE_ID === this.factura.RECEIVER_CFDI_USE_ID);

    const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
    const idOrganizacion = usuarioSession.ORGANIZATION_ID;
    const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
    const fechaActual = new Date();
    const mes = fechaActual.getMonth() + 1;
    const hora = fechaActual.getHours();
    const minutos = fechaActual.getMinutes();
    const segundos = fechaActual.getSeconds();
    const fechaActualString = fechaActual.getFullYear() + '-' +
      ((mes > 9) ? mes : '0' + mes)  + '-' +
      ((fechaActual.getDate() > 9) ? fechaActual.getDate() : '0' + fechaActual.getDate() )  + 'T' +
      ((hora > 9) ? hora : '0' + hora)  + ':' +
      ((minutos > 9) ? minutos : '0' + minutos) + ':' +
      ((segundos > 9) ? segundos : '0' + segundos) ;
    const comprobante: any = {
        Version: '4.0',
        Fecha: fechaActualString, // FORMATO: yyyy-MM-ddThh:mm:ss
        FormaPago: formaPagoNull ?  null: formaPago.BILL_PAYMENT_FORM_KEY,
        //FormaPago: formaPago.BILL_PAYMENT_FORM_KEY,
        SubTotal: this.factura.SUBTOTAL_BEFORE_TAX,
        Moneda: this.factura.INVOICE_TYPE == "T"? "XXX" :(this.factura.CURRENCY !== null ? this.factura.CURRENCY : 'MXN'),
        Total: this.factura.TOTAL,
        //TipoDeComprobante: this.factura.INVOICE_TYPE == null? "I" :  this.factura.INVOICE_TYPE == "IC"? "I" : this.factura.INVOICE_TYPE,
        TipoDeComprobante: this.factura.INVOICE_TYPE == null? "I" : this.factura.INVOICE_TYPE,
        Folio: 'F',
        Serie: this.factura.BILL_NUMBER,
        MetodoPago: metodoPagoNull ?  null: metodoPago.BILL_PAYMENT_METHOD_KEY,
       // MetodoPago: metodoPago.BILL_PAYMENT_METHOD_KEY,
        LugarExpedicion: '',
        Emisor: {
        // Nombre: 'Osmar Roque',
        // Rfc: 'AAA010101AAA',
          RegimenFiscal: regimenFiscal.BILL_TAX_REGIME_KEY
        },
        Receptor: {
        // Nombre: 'Mauricio Paredes',
        // Rfc: 'LAN8507268IA',
          UsoCFDI: usoCFDI.BILL_CFDI_USE_KEY
        },
        Conceptos: conceptos,
        Impuestos: {

        }
      };
    if (tieneImpuestos) {
            comprobante.Impuestos =  {
              Impuesto: '002',
              //     ,
              //  TotalImpuestosRetenidos: this.factura.Total_ImpuestosRetenidos, totalImpuestosRetenidosFieldSpecified: false,
              Traslados: [
                  // {Impuesto: '002', TipoFactor: 'Tasa', TasaOCuota: '0.160000', Importe: 48.00}
                ],
              Retenciones: [
                // {Impuesto: '002', TipoFactor: 'Tasa', TasaOCuota: '0.160000', Importe: 48.00}
              ]
              };
              console.warn(this.factura);
            // Si se manejan mas tipos de impuestos, hay que insertar un traslado de cada tipo
            if(this.factura.TOTAL_IVA > 0)
            {
                
              comprobante.Impuestos.TotalImpuestosTrasladados = this.factura.TOTAL_IVA.toFixed(2);
                 
              comprobante.Impuestos.totalImpuestosTrasladadosFieldSpecified = false;

              comprobante.Impuestos.Traslados.push({
                objetoImp: "02",
  
                Impuesto: '002', TipoFactor: 'Tasa', TasaOCuota: '0.160000'
                , Importe: this.factura.TOTAL_IVA.toFixed(2)
                , baseField: ""+this.factura.SUBTOTAL_BEFORE_TAX.toFixed(2)
              });
  
            }

            if(this.factura.Total_ImpuestosRetenidos != null)
            {
              comprobante.Impuestos.TotalImpuestosRetenidos =  this.factura.Total_ImpuestosRetenidos;
              comprobante.Impuestos.totalImpuestosRetenidosFieldSpecified = false;
              if(this.factura.Total_ImpuestosRetenidos > 0)
              {
                comprobante.Impuestos.Retenciones.push({
                  objetoImp: "02",
                  Impuesto: '001', TipoFactor: 'Tasa', TasaOCuota: '0.100000'
                  , Importe: this.factura.Total_ImpuestosRetenidos.toFixed(2)
                  , baseField: ""+this.factura.SUBTOTAL_BEFORE_TAX.toFixed(2)
                });
              }
            }
      }

    const params: any = {};
    params.comprobante = comprobante;
    params.cliente = { idCliente: this.clienteForm.value ? this.clienteForm.value : idCliente };
    params.compania = { idCompania };
    params.descripcionSAT = {
      formaPago: formaPagoNull ?  null: formaPago.BILL_PAYMENT_FORM_KEY + ' - ' + formaPago.DESCRIPTION,
      //formaPago: formaPago.BILL_PAYMENT_FORM_KEY + ' - ' + formaPago.DESCRIPTION,
      metodoPago: metodoPagoNull ?  null: metodoPago.BILL_PAYMENT_METHOD_KEY + ' - ' + metodoPago.DESCRIPTION,
      //metodoPago: metodoPago.BILL_PAYMENT_METHOD_KEY + ' - ' + metodoPago.DESCRIPTION,
      regimenFiscal: regimenFiscal.BILL_TAX_REGIME_KEY + ' - ' + regimenFiscal.DESCRIPTION,
      usoCFDI: usoCFDI.BILL_CFDI_USE_KEY,
      tipoComprobante: this.factura.INVOICE_TYPE == null? "I - Ingreso" :  this.factura.INVOICE_TYPE == "IC" || this.factura.INVOICE_TYPE == "I"? "I - Ingreso" : this.factura.INVOICE_TYPE == "T"? "T - Traslado" : this.factura.INVOICE_TYPE,
    };
    params.factura = { 
      ORGANIZATION_ID: idOrganizacion, 
      BILL_ID: this.factura.BILL_ID, 
      loacs: sessionStorage.getItem('acslo')
    };

    let totalImpuestosRetenidos = 0;

    this.listaFacturaDetalleImpuestosRetenidos.forEach(elemento => {
      totalImpuestosRetenidos += elemento.AMOUNT;
    });

    params.ImpuestosRetenidosTotal = {
      totalImpuestosRetenidos
    }
    
    params.facturaDetalle = {
      
    }


    


    let contadorO = 0;
    let contadorD = 0;
      
    for (let i = 0; i < this.listaCartaPorteDetalleUbicaciones.length; i++) {
        
            let  opcionOD = "";
            if ( this.listaCartaPorteDetalleUbicaciones[i]['BILL_CARTA_PORTE_TYPE'] === 'O') {
                contadorO++;
                opcionOD = 'OR'  + contadorO.toString().padStart(6, '0');
                
            }
            if (this.listaCartaPorteDetalleUbicaciones[i]['BILL_CARTA_PORTE_TYPE'] === 'D') {
                contadorD++;
                opcionOD = 'DE' + contadorD.toString().padStart(6, '0');
            }
           
        this.listaCartaPorteDetalleUbicaciones[i].ID_origendestino = opcionOD;
        const modeloAuxiliarUbicaciones: any = {
            ID_origendestino:opcionOD,  
            BILL_CARTA_PORTE_ADDRESS_ID: this.listaCartaPorteDetalleUbicaciones[i].BILL_CARTA_PORTE_ADDRESS_ID,
            BILL_CARTA_PORTE_ID: this.listaCartaPorteDetalleUbicaciones[i].BILL_CARTA_PORTE_ID,
            BILL_CARTA_PORTE_TYPE: this.listaCartaPorteDetalleUbicaciones[i].BILL_CARTA_PORTE_TYPE,
            UBICACION_number: this.listaCartaPorteDetalleUbicaciones[i].UBICACION_number,
            COMPANY_ADDRESS_ID: this.listaCartaPorteDetalleUbicaciones[i].COMPANY_ADDRESS_ID,
            CUSTOMER_ADDRESS_ID: this.listaCartaPorteDetalleUbicaciones[i].CUSTOMER_ADDRESS_ID,
            DATETIME: this.listaCartaPorteDetalleUbicaciones[i].DATETIME,
            RFC: this.listaCartaPorteDetalleUbicaciones[i].RFC,
            DISTANCE: this.listaCartaPorteDetalleUbicaciones[i].DISTANCE,
            CITY_ID: this.listaCartaPorteDetalleUbicaciones[i].CITY_ID,
            SUBURB: this.listaCartaPorteDetalleUbicaciones[i].SUBURB,
            STREET: this.listaCartaPorteDetalleUbicaciones[i].STREET,
            OUTDOOR_NUMBER: this.listaCartaPorteDetalleUbicaciones[i].OUTDOOR_NUMBER,
            INTERIOR_NUMBER: this.listaCartaPorteDetalleUbicaciones[i].INTERIOR_NUMBER,
            POSTAL_CODE: this.listaCartaPorteDetalleUbicaciones[i].POSTAL_CODE,
            REFERENCE: this.listaCartaPorteDetalleUbicaciones[i].REFERENCE,
            MUNICIPIO_NAME: this.listaCartaPorteDetalleUbicaciones[i].MUNICIPIO_NAME,
            C_MUNICIPIO: this.listaCartaPorteDetalleUbicaciones[i].C_MUNICIPIO,
            ESTADO_NAME: this.listaCartaPorteDetalleUbicaciones[i].ESTADO_NAME,
            C_ESTADO: this.listaCartaPorteDetalleUbicaciones[i].C_ESTADO,
            PAIS: this.listaCartaPorteDetalleUbicaciones[i].PAIS,
            UBICACIONES_NAME: this.listaCartaPorteDetalleUbicaciones[i].UBICACIONES_NAME,
            DISTANCIA: this.listaCartaPorteDetalleUbicaciones[i].DISTANCIA,
            DOMICILIO: this.listaCartaPorteDetalleUbicaciones[i].DOMICILIO,
            origenDestino_Name: this.listaCartaPorteDetalleUbicaciones[i].origenDestino_Name,
            LOCATION_ID: this.listaCartaPorteDetalleUbicaciones[i].LOCATION_ID,
            C_LOCALIDAD: this.listaCartaPorteDetalleUbicaciones[i].C_LOCALIDAD,
        };
        this.lista_CartaPorteDetalleUbicaciones.push(modeloAuxiliarUbicaciones);
    }
      for (let i = 0; i < this.listaCartaPorteDetallePesoCarga.length; i++) {
        let  origen = "";
        let  destino = "";
        const origenOpcion = this.lista_CartaPorteDetalleUbicaciones.find((p) => p.BILL_CARTA_PORTE_ADDRESS_ID === this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_ORI_ADDRESS_ID); 
        if (origenOpcion !== null && origenOpcion !== undefined){
          //origen = "";
          origen = origenOpcion.ID_origendestino;
        } 
        const destinoOpcion = this.lista_CartaPorteDetalleUbicaciones.find((p) => p.BILL_CARTA_PORTE_ADDRESS_ID === this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_DEST_ADDRESS_ID); 
        if (destinoOpcion !== null && destinoOpcion !== undefined){
         // destino = "";
          destino = destinoOpcion.ID_origendestino;
        } 
        const modeloAuxiliarPesoCarga: any = {
          ORIGEN:origen,// integro Origen Destino con formato
          DESTINO:destino,
          GROSS_WEIGHT: this.listaCartaPorteDetallePesoCarga[i].GROSS_WEIGHT,
          NET_WEIGHT: this.listaCartaPorteDetallePesoCarga[i].NET_WEIGHT,
          QUANTITY: this.listaCartaPorteDetallePesoCarga[i].QUANTITY,
          CHARGE: this.listaCartaPorteDetallePesoCarga[i].CHARGE,
          ITEM_ID: this.listaCartaPorteDetallePesoCarga[i].ITEM_ID,
          PRODUCT_Name: this.listaCartaPorteDetallePesoCarga[i].PRODUCT_Name,
          BILL_UNIT_MEASURE_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_UNIT_MEASURE_ID,
          BILL_UNIT_MEASURE_KEY: this.listaCartaPorteDetallePesoCarga[i].BILL_UNIT_MEASURE_KEY,
          BILL_CARTA_PORTE_WEIGHT_DETAIL_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_WEIGHT_DETAIL_ID,
          BILL_CARTA_PORTE_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_ID,
          DIMENSIONS: this.listaCartaPorteDetallePesoCarga[i].DIMENSIONS,
          BILL_PACKAGING_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_PACKAGING_ID,
          EMBALAJE_NAME: this.listaCartaPorteDetallePesoCarga[i].EMBALAJE_NAME,
          CLAVEMATERIALPELIGROSO: this.listaCartaPorteDetallePesoCarga[i].CLAVEMATERIALPELIGROSO,
          HAZARDOUS_MATERIAL_ID: this.listaCartaPorteDetallePesoCarga[i].HAZARDOUS_MATERIAL_ID,
          MATERIALPELIGROSO_NAME: this.listaCartaPorteDetallePesoCarga[i].MATERIALPELIGROSO_NAME,
          ITEM_SAT_ID: this.listaCartaPorteDetallePesoCarga[i].ITEM_SAT_ID,
          NAME_SAT: this.listaCartaPorteDetallePesoCarga[i].NAME_SAT,
          DESCRIPTION: this.listaCartaPorteDetallePesoCarga[i].DESCRIPTION,
          satID: this.listaCartaPorteDetallePesoCarga[i].satID,
          PRODUCTO_DPC: this.listaCartaPorteDetallePesoCarga[i].PRODUCTO_DPC,
          UNIDAD_NAME: this.listaCartaPorteDetallePesoCarga[i].UNIDAD_NAME,
          BILL_CARTA_PORTE_ORI_ADDRESS_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_ORI_ADDRESS_ID,
          IdOrigen_DPC: this.listaCartaPorteDetallePesoCarga[i].IdOrigen_DPC,
          BILL_CARTA_PORTE_DEST_ADDRESS_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_DEST_ADDRESS_ID,
          IdDestino_DPC: this.listaCartaPorteDetallePesoCarga[i].IdDestino_DPC,
        };
        this.lista_CartaPorteDetallePesoCarga.push(modeloAuxiliarPesoCarga);
      }

    params.cartaPorte = this.factura.BILL_CARTA_PORTE_ID == null? null : {
                          ORGANIZATION_ID: idOrganizacion,
                          BILL_ID: this.factura.BILL_ID,
                          //loacs: "cartaPorte",
                          lista_CartaPorte:this.listaCartaPorte,
                          lista_CartaPorteDetallePesoCarga:this.lista_CartaPorteDetallePesoCarga,
                          //lista_CartaPorteDetalleServicos:this.listaCartaPorteDetalleServicos,
                          lista_CartaPorteDetalleTrasporte:this.listaCartaPorteDetalleTrasporte,
                          lista_CartaPorteDetalleUbicaciones:this.lista_CartaPorteDetalleUbicaciones
                        };

    // Sustitución: CFDI Relacionados (TipoRelacion 04) hacia el/los UUID de la(s) factura(s) previa(s).
    // Se envía como OBJETO dentro de comprobante (igual que Nota Crédito). El BACK lo captura,
    // lo anula antes del pass-through y lo inyecta como arreglo en el DTO (timbrarFactura4).
    if (this.listaFacturaDocumentosRelacionados && this.listaFacturaDocumentosRelacionados.length > 0) {
      const cfdiRelacionados: any = { TipoRelacion: '04', CfdiRelacionado: [] };
      this.listaFacturaDocumentosRelacionados.forEach((d) => {
        cfdiRelacionados.CfdiRelacionado.push({ UUID: d.UUID });
      });
      comprobante.CfdiRelacionados = cfdiRelacionados;
      params.CfdiRelacionados = cfdiRelacionados;
    }

    return params;
  }

  cargarDocumentosRelacionados(billId: any, callback: () => void) {
    const factura: any = { BILL_ID: billId };
    this._generalService.metodoCallParams(factura, 'factura/getBillDocumentosRelacionados/').subscribe(
      (result) => {
        const res = JSON.parse(result);
        this.listaFacturaDocumentosRelacionados = (res !== null && res !== undefined) ? res : [];
        callback();
      },
      (error) => {
        this.listaFacturaDocumentosRelacionados = [];
        callback();
      }
    );
  }

  descargarArchivos() {
    const blob = this.base64PDFToBlob(this.PDF);

    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = this.FILENAME_PDF + '.pdf';
    // some browser needs the anchor to be in the doc
    document.body.appendChild(link);
    link.click();
    link.remove();

    const bb = new Blob([this.XML], {type: 'text/plain'});

    link = document.createElement('a');
    link.href = URL.createObjectURL(bb);
    link.download = this.FILENAME_XML + '.xml';
    // some browser needs the anchor to be in the doc
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  crearPDF() {
    const params = {};
    this._generalService.requestPostParams(params, 'factura/crearPDF/').subscribe(
      (result) => {
        const archivo = result;
        const blob = this.base64PDFToBlob(archivo);
        window.open(URL.createObjectURL(blob));
      },
      (error) => {
      
      }
    );
  }

  base64PDFToBlob(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: 'application/pdf' });
  }

  consultarUnidades() {
    this._generalService.metodoCall(`factura/getUnidades/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaUnidad = res;
            } else {
                this.listaUnidad = [];
            }
        },
        (error) => {
            this.listaUnidad = [];
          
        }
    );
}

consultSATcode() {
  this._generalService.metodoCall(`itemCodeSAT/consultItemSATcodes/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaSATCode = res;
          } else {
              this.listaSATCode = [];
          }
      },
      (error) => {
          this.listaSATCode = [];
    
      }
  );
}

consultarSucursales() {
  this._generalService.metodoCall(`compania/consultarSucursales/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaSucursal = res;
          } else {
              this.listaSucursal = [];
          }
      },
      (error) => {
          this.listaSucursal = [];
        
      }
  );
}

consultarRegimenFiscales() {
  this._generalService.metodoCall(`factura/getRegimenFiscal/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaRegimenFiscal = res;
          } else {
              this.listaRegimenFiscal = [];
          }
      },
      (error) => {
          this.listaRegimenFiscal = [];
     
      }
  );
}

consultarFormaPago() {
  this._generalService.metodoCall(`factura/getFormaPago/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaFormaPago = res;
          } else {
              this.listaFormaPago = [];
          }
      },
      (error) => {
          this.listaFormaPago = [];
      
      }
  );
}

consultarMetodoPago() {
  this._generalService.metodoCall(`factura/getMetodoPago/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaMetodoPago = res;
          } else {
              this.listaMetodoPago = [];
          }
      },
      (error) => {
          this.listaMetodoPago = [];
       
      }
  );
}

consultarCFDI() {
  this._generalService.metodoCall(`factura/getCFDI/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaCFDI = res;
          } else {
              this.listaCFDI = [];
          }
      },
      (error) => {
          this.listaCFDI = [];
         
      }
  );
}

fetchMore() {
  if(this.itemsShow < this.listaCliente.length) {
    this.itemsShow += 10;
    this.viewDataCliente = this.listaCliente.slice(0, this.itemsShow);
  }  
}

  onKeyUpCliente(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredCliente = this.listaCliente.filter((obj) => {
        return obj.razonSocial.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })

      arr = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
      this.isFilteredCliente = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredCliente = false;
      this.filteredItemsShowCliente = 10;
      this.arrayFilteredCliente = undefined;
      arr = this.listaCliente.slice(0, this.itemsShow);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    this.viewDataCliente = arr;
    /***************************INFINITE SELECT**********************************/
  }

  /***************************INFINITE SELECT**********************************/
  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredCliente) {
        if(this.filteredItemsShowCliente < this.arrayFilteredCliente.length) {
            this.filteredItemsShowCliente += 10;
            this.viewDataCliente = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
        }
      } else {
        if(this.itemsShow < this.listaCliente.length) {
          this.itemsShow += 10;
          this.viewDataCliente = this.listaCliente.slice(0, this.itemsShow);
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/

  /********** Envio por correo pdf and xml (INICIO) */
  preparPDFYXMLEnvioPorCorreo(id: any, idCliente: any){
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.listaFacturaDocumentosRelacionados = [];
      this.factura = new Factura();
      this.factura.BILL_ID = id;
      this._generalService.metodoCallParams(this.factura, `factura/getBill/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res.length > 0) {
                    this.factura = res[0];
                    this._generalService.metodoCallParams(this.factura, `factura/getBillDetail/`).subscribe(
                        (result2) => {
                            const res2 = JSON.parse(result2);
                          
                            this.listaFacturaDetalle = res2;
                            
                            this.enviarPDFYXMLPorCorreo(idCliente);
                        },
                        (error) => {
                          this.btnSubmit = false;
                          this.datosGeneralesSAE.showSpinnerLoading = false;
                      
                        }
                    );

                } else {
                  this.btnSubmit = false;
                  this.datosGeneralesSAE.showSpinnerLoading = false;
                }
            },
            (error) => {
              this.btnSubmit = false;
              this.datosGeneralesSAE.showSpinnerLoading = false;
      
            }
        );
        }
  }

  enviarPDFYXMLPorCorreo(idCliente: any)
  {
    
    const params = this.generarComprobante(idCliente);
    this._generalService.requestPostParams(params, 'factura/enviarArchivosDeFacturaPorEmail/').subscribe(
      (result) => {
        this.btnSubmit = false;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const response = result;
        if(response == "ok")
        {
          this._generalService.toastCall("Envio por E-Mail Correctamente");
        }
        else
        {
          this._generalService.toastCall(response);
        }
        
      },
      (error) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
        this.btnSubmit = false;
      }
    );
  }
  /********** Envio por correo pdf and xml (FIN) */


  generarCarta(idCliente: number,  BILL_ID: any, BILL_TYPE:any){
    const dialogRef = this.dialog.open(CartaPorte, {
      disableClose: true, 
      width: '95vw',
      height: '90vh',
      maxWidth: '95vw', 
      maxHeight: '95vh', 
      panelClass: 'full-width-dialog',
      data: {
        idCliente: idCliente,
        BILL_ID: BILL_ID,
        BILL_TYPE:BILL_TYPE
      } });
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((res) => {
      this.consultarFacturas();
    });
    
  }

  fechaPagoFactura(id: number, BILL_ID: any) {
    const dialogRef = this.dialog.open(modalFechaPagoFactura, {
     disableClose: true, 
     width:'30%', 
     maxWidth:'70%', 
     panelClass: 'full-width-dialog',
     data: {
       id: id,
       BILL_ID: BILL_ID
     }
    });
    this.dataService.dialogRef = dialogRef; 

    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
        this.consultarFacturas();
        //this.regresarFacturas();
    });
  }

  validarVistaBtn(){
    let personal = new Personal();
    const permisoIcono = 'ACCE0001'
    personal.loacs = sessionStorage.getItem("acslo");
    this._generalService.metodoCallParams(personal, "usuario/consultarMenu").subscribe(
      result => {
        this.menuItemsPerfil = JSON.parse(result);
        for(let menu of this.menuItemsPerfil) {
          if(permisoIcono == menu.codigo) {
            this.iconoMostar = false;
            break;
          }else{
            this.iconoMostar = true;
          }
        }
        this.consultarClientes();
      this.getDocumentsTypes();
      this.consultarCFDI();
      this.consultarFormaPago();
      this.consultarMetodoPago();
      this.consultarRegimenFiscales();
      this.consultarSucursales();
      this.consultarUnidades();
      this.consultSATcode();

      this.consultarFacturas();
      }, 
      error => {
        console.log(error);
      }
    )
  }

 
 

}



// WEBPACK FOOTER //
// ./src/app/factura/consultar-eliminar/factura-consultar.component.ts